import React, { useState } from 'react';
import styled from 'styled-components';

interface Position {
  x: number;
  y: number;
}

interface FilterListProps {
  position: Position;
  theme?: any;
  listData: any;
  handleFilteredData: (data: string[]) => void;
  selectedFilterList?: string[];
}

const ListStyledDiv = styled.div`
&::-webkit-scrollbar {
                            width: 8px;
                        }
                        &::-webkit-scrollbar-track {
                            background-color: #f1f1f1;
                        }
                        &::-webkit-scrollbar-thumb {
                            background-color: #888;
                            border-radius: 4px;
                        }
                        &::-webkit-scrollbar-thumb:hover {
                            background-color: #555;
                        }
`;


const ColumnFilterList: React.FC<FilterListProps> = ({
  position,
  listData,
  handleFilteredData,
  selectedFilterList,
  theme,
}) => {
  const listStyle: React.CSSProperties = {
    width: '250px',
    maxHeight: '200px',
    position: 'absolute',
    overflow: 'auto',
    padding: '10px',
    borderRadius: '12px',
    gap: '5px',
    boxShadow: '0px 4px 3px rgba(0, 0, 0, 0.2)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    backgroundColor: theme.table.style.backgroundColor,
    left: `${position?.x}px`,
    top: `${position?.y}px`,


  };
  const checkboxStyle: React.CSSProperties = {
    accentColor: theme.expanderButton.style.color,
  };
  const [selectedFilter, setSelectedFilter] = useState<string[]>(selectedFilterList || []);
  const [availableValues, setAvailableValues] = useState<string[]>(
    listData.filter((item: string) => !selectedFilter.includes(item))
  );

  const handleFilter = (event: any) => {
    const searchText = event.target.value;
    const filteredData = listData.filter((item: string) =>
      item.toLowerCase().includes(searchText.toLowerCase())
    );
    setAvailableValues(filteredData.filter((item: string) => !selectedFilter.includes(item)));
  };

  const handleAvailableValueCheck = (value: string) => {
    setSelectedFilter((prevState) => {
      const newFilter = [...prevState, value];
      setAvailableValues((prevAvailableValues) =>
        prevAvailableValues.filter((item) => item !== value)
      );
      handleFilteredData(newFilter);
      return newFilter;
    });
  };

  const handleSelectedValueUncheck = (value: string) => {
    setSelectedFilter((prevState) => {
      const newFilter = prevState.filter((item) => item !== value);
      setAvailableValues((prevAvailableValues) => [...prevAvailableValues, value]);
      handleFilteredData(newFilter);
      return newFilter;
    });
  };
  const selectAll = () => {
    setSelectedFilter(listData);
    setAvailableValues([]);
    handleFilteredData(listData);
  }



  return (
    <ListStyledDiv style={listStyle} id="filterBox">
      <input
        type="text"
        onChange={handleFilter}
        placeholder="Search"
        style={{ padding: '5px', border: '1px solid #E2E8F0', borderRadius: '8px', backgroundColor: 'transparent' }}
      />
      <div id="selectedValues">
        {selectedFilter.map((value: string, index: any) => (
          <div key={index} style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', gap: '2px' }}>
            <input type="checkbox" onChange={() => handleSelectedValueUncheck(value)} checked style={checkboxStyle} />
            <span title={value}>
              {value.length > 20 ? value.substring(0, 20) + '...' : value}
            </span>
          </div>
        ))}
      </div>
      <hr style={{ borderColor: '#f7f7f7', margin: '0px 0px' }} />

      <div id="availableValues">
        <button onClick={selectAll}
          style={{
            border: "1px solid", borderColor: theme.expanderButton.style.color, backgroundColor: theme.table.style.backgroundColor,
            width: '100%', borderRadius: '5px', cursor: 'pointer', color: theme.expanderButton.style.color,
            margin: '5px 0px',
            padding: '5px 0px',
            fontWeight: 'bold'
          }}
        > Select All</button>

        {availableValues.map((value: string, index: any) => (
          <div key={index} style={{
            display: 'flex', justifyContent: 'flex-start', alignItems: 'center', gap: '10px',
            width: '100%',
            margin: '5px 0',
            padding: '2px 0',
          }}>
            <input
              type="checkbox"
              checked={false}
              onChange={(e) => {
                e.stopPropagation();
                handleAvailableValueCheck(value);
              }}
              style={checkboxStyle}
            />
            <span title={value} >{value.length > 20 ? value.substring(0, 20) + '...' : value}</span>
          </div>
        ))}
      </div>
    </ListStyledDiv >
  );
};

export default ColumnFilterList;
